export { NicheScopeProvider } from './niche-scope.provider'
export { useNicheScope } from './niche-scope.hook'
